import { Box, Button, Grid, MobileStepper, Skeleton, useTheme } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomTextField from "../../../CustomComponents/CustomTextField";
import { convertDateWithValidation, validate } from "../../helper/losDataHelper";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { useState } from "react";

const TechnicalDetail = ({ technicalDetailsList }) => {

   const theme = useTheme();
   const [activeStep, setActiveStep] = useState(0);

  const maxSteps = validate(technicalDetailsList) ?  technicalDetailsList.length : 0;

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

   const technicalDetailComponent = () => {
      const technicalDetails = validate(technicalDetailsList) ? technicalDetailsList[activeStep] : undefined;
      return (
         <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Internal Application ID"
                variant="standard"
                placeholder="Enter Internal Application ID"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.internalApplicationId : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Internal Technical ID"
                variant="standard"
                placeholder="Enter Internal Technical ID"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.internalTechnicalId : ""}
              />
              </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Internal Applicant ID"
                variant="standard"
                placeholder="Enter Internal Applicant ID"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.internalApplicantId : ""}
              />
              </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Application Number"
                variant="standard"
                placeholder="Enter Application Number"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.applicationNumber : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Customer ID"
                variant="standard"
                placeholder="Enter Customer ID"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.customerId : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Appriser Type ID"
                variant="standard"
                placeholder="Enter Appriser Type ID"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.appriserTypeId : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Appriser Code"
                variant="standard"
                placeholder="Enter Appriser Code"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.appriserCode : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Appriser Name"
                variant="standard"
                placeholder="Enter Appriser Name"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.appriserName : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Appriser Mobile Number"
                variant="standard"
                placeholder="Enter Appriser Mobile Number"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.appriserMobileNumber : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Technical Clearance"
                variant="standard"
                placeholder="Enter Technical Clearance"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.technicalClearance : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="PVR Document ID"
                variant="standard"
                placeholder="Enter PVR Document ID"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.pvrDocumentId : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="PVR Document Name"
                variant="standard"
                placeholder="Enter PVR Document Name"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.pvrDocumentName : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Recommended Ltv"
                variant="standard"
                placeholder="Enter Recommended Ltv"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.recommendedLtv : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Apprised Date"
                variant="standard"
                placeholder="Enter Apprised Date"
                disabled={true}
                value={validate(technicalDetails) ? convertDateWithValidation(technicalDetails.apprisedDate) : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Recommendation"
                variant="standard"
                placeholder="Enter Recommendation"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.recommendation : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="CTH Name"
                variant="standard"
                placeholder="Enter CTH Name"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.cthName : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Recommendation CTH"
                variant="standard"
                placeholder="Enter Recommendation CTH"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.recommendationCth : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Technical Approved Date"
                variant="standard"
                placeholder="Enter Technical Approved Date"
                disabled={true}
                value={technicalDetails !== undefined ? convertDateWithValidation(technicalDetails.technicalApprovedDate) : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Task Status"
                variant="standard"
                placeholder="Enter Task Status"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.taskStatus : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="CTH Task Status"
                variant="standard"
                placeholder="Enter CTH Task Status"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.cthTaskStatus : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Task State ID"
                variant="standard"
                placeholder="Enter Task State ID"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.taskStateId : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}> 
             <CustomTextField
                type="text"
                label="Task State"
                variant="standard"
                placeholder="Enter Task State"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.taskState : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Parent ID"
                variant="standard"
                placeholder="Enter Parent ID"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.parentId : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Realizable Land Value"
                variant="standard"
                placeholder="Enter Realizable Land Value"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.realizableLandValue : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Building Value"
                variant="standard"
                placeholder="Enter Building Value"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.buildingValue : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Amenities Service Cost"
                variant="standard"
                placeholder="Enter Amenities Service Cost"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.amenitiesServiceCost : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Land Value"
                variant="standard"
                placeholder="Enter Land Value"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.landValue : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Flat Total Value"
                variant="standard"
                placeholder="Enter Flat Total Value"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.flatTotalValue : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Created By"
                variant="standard"
                placeholder="Enter Created By"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.createdBy : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Modified By"
                variant="standard"
                placeholder="Enter Modified By"
                disabled={true}
                value={technicalDetails !== undefined ? technicalDetails.modifiedBy : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Created Date"
                variant="standard"
                placeholder="Enter Created Date"
                disabled={true}
                value={technicalDetails !== undefined ? convertDateWithValidation(technicalDetails.createdDate) : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Modified Date"
                variant="standard"
                placeholder="Enter Modified Date"
                disabled={true}
                value={technicalDetails !== undefined ? convertDateWithValidation(technicalDetails.modifiedDate) : ""}
              />
              </Grid>
              </Grid>
      );
   }

    return(
         <AccordianContainer
          id="accord"
          title="Technical Details"
          initialOpen={false}
        >
        <Box sx={{ marginTop: "-1%" }}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                         <Box sx={{ display: "flex", justifyContent:"center", alignItems: "center", marginBottom: "8px"}}>
                        { maxSteps > 1 && <MobileStepper
                          variant="text"
                          steps={maxSteps}
                          position="static"
                          activeStep={activeStep}
                          sx={{ maxWidth: 400, flexGrow: 1, boxShadow: 2 }} 
                            nextButton={
                            <Button size="small" sx={{ color:"#003f7c" }} onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                                Next
                            {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                            ) : ( <KeyboardArrowRight /> )}
                           </Button>
                         }
                        backButton={
                        <Button size="small" onClick={handleBack} sx={{ color:"#003f7c" }} disabled={activeStep === 0}>
                        {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                        ) : (
                            <KeyboardArrowLeft />
                        )}
                            Back
                        </Button>
                    }
                    /> }
                    </Box>
                    </Grid>
                    { technicalDetailComponent() }
        </Box>
        </AccordianContainer>
);
}

export default TechnicalDetail;